module.exports = __webpack_public_path__ + "static/media/MPSPpay.aa3e8edb.png";